export const DefaultPrefix = 'ngx-webstorage';
export const DefaultSeparator = '|';
export const DefaultIsCaseSensitive = false;
